import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import logoDark from '../assets/images/logo-dark.png'
import logoLight from '../assets/images/logo-light.png'
import { Link as Link1 } from "react-scroll";

export default function Navbar(){

    let [scroll, setScroll] = useState(false);
    let [manu, setManu] = useState(false)

    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 50);
        });
        return()=>{
            window.removeEventListener("scroll", () => {
                setScroll(window.scrollY > 50);
            });
        }
    }, []);
   
    return(
        <div>            

        <nav className={`navbar ${scroll ? 'is-sticky' : ''}`} id="navbar">
            <div className="container relative flex flex-wrap items-center justify-between">
           
                <Link className="navbar-brand md:me-8" to="/">
                    <img src={logoDark} className="inline-block dark:hidden  w-40 md:w-52" alt=""/>
                    <img src={logoLight} className="hidden dark:inline-block w-40 md:w-52" alt=""/>
                </Link>

                <div className="nav-icons flex items-center lg_992:order-2 ms-auto md:ms-8">
                    <button 
                        data-collapse="menu-collapse" 
                        type="button" 
                        className="mobile-menu-btn inline-flex items-center ms-2 text-white bg-gray-800 hover:bg-gray-700 border border-gray-600 rounded-md p-2 transition-colors lg_992:hidden" 
                        onClick={() => setManu(!manu)}
                    >
                        <span className="sr-only">Navigation Menu</span>
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                </div>

                <div className={`navigation lg_992:order-1 lg_992:flex ${manu ? 'block' : 'hidden'} lg_992:block ms-auto`} id="menu-collapse">
                    <ul className="navbar-nav" id="navbar-navlist">
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" to="home" smooth={true} duration={1000} activeClass='active' spy={true} onClick={() => setManu(false)}>Home</Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" to="about" smooth={true} duration={1000} activeClass='active' spy={true} onClick={() => setManu(false)}>About</Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" to="services" smooth={true} duration={1000} activeClass='active' spy={true} onClick={() => setManu(false)}>Services</Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" to="blog" smooth={true} duration={1000} activeClass='active' spy={true} onClick={() => setManu(false)}>Projects</Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" to="contact" smooth={true} duration={1000} activeClass='active' spy={true} onClick={() => setManu(false)}>Contact us</Link1>
                        </li>
                    </ul>
                </div>
            </div>

            {/* Mobile menu styles */}
            <style jsx>{`
                @media (max-width: 991.98px) {
                    .navbar {
                        background-color: #0e191c !important;
                        padding: 1rem 0;
                    }
                    
                    /* Force mobile menu button to be always visible */
                    .mobile-menu-btn {
                        display: flex !important;
                        visibility: visible !important;
                        opacity: 1 !important;
                        z-index: 1001;
                        position: relative;
                    }
                    
                    #menu-collapse {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        background-color: #0e191c;
                        z-index: 1000;
                        padding-top: 80px;
                        transition: all 0.3s ease-in-out;
                    }
                    
                    .navbar-nav {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        padding: 0 20px;
                    }
                    
                    .nav-item {
                        width: 100%;
                    }
                    
                    .nav-link {
                        display: block;
                        padding: 15px 20px;
                        color: #e2e8f0 !important; /* Light gray color for mobile */
                        font-size: 18px;
                        font-weight: 500;
                        border-bottom: 1px solid #2d3748;
                        text-decoration: none;
                        transition: all 0.3s ease;
                    }
                    
                    .nav-link:last-child {
                        border-bottom: none;
                    }
                    
                    .nav-link:hover {
                        color: #0d9488 !important;
                        background-color: rgba(13, 148, 136, 0.1);
                    }
                    
                    .nav-link.active {
                        color: #0d9488 !important;
                        background-color: rgba(13, 148, 136, 0.15);
                    }
                }

                /* Desktop styles remain exactly the same */
                @media (min-width: 992px) {
                    #menu-collapse {
                        display: flex !important;
                    }
                    
                    .navbar-nav {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                    }
                    
                    .nav-item {
                        margin-left: 2rem;
                    }
                    
                    .nav-link {
                        padding: 0.5rem 0;
                        color: inherit;
                        text-decoration: none;
                        position: relative;
                        cursor: pointer;
                    }
                    
                    .nav-link.active {
                        color: #0d9488;
                    }
                    
                    .nav-link:hover {
                        color: #0d9488;
                    }

                    /* Hide menu button on desktop */
                    .mobile-menu-btn {
                        display: none !important;
                    }
                }

                /* Global styles to ensure button visibility */
                .mobile-menu-btn {
                    display: flex;
                    visibility: visible;
                    opacity: 1;
                }
            `}</style>
        </nav>
        </div>
    )
}